export default {
  // Console tabs (ConsoleTabs on md+, BottomTabs on phones)
  tabs: {
    label: 'Hlavní navigace',
    home: 'Domů',
    browse: 'Katalog',
    search: 'Hledat',
    wishlist: 'Oblíbené',
    account: 'Účet',
  },
  nav: {
    catalog: 'Katalog',
    allGames: 'Všechny hry',
    preorders: 'Předobjednávky',
    help: 'Nápověda',
  },
  search: {
    placeholder: 'Hledat hry, DLC, dárkové karty…',
    recent: 'Nedávná hledání',
    // Plural: 1 výsledek | 2–4 výsledky | 5+ výsledků
    seeAll: 'Zobrazit {count} výsledek | Zobrazit všechny {count} výsledky | Zobrazit všech {count} výsledků',
  },
  palette: {
    label: 'Rychlé hledání',
    recentlyViewed: 'Naposledy zobrazené',
    goTo: 'Přejít na',
    forget: 'Odebrat „{term}“ z nedávných hledání',
  },
  aria: {
    home: 'KeyzoStore — domů',
    search: 'Hledat hry',
    favorites: 'Moje oblíbené',
    cart: 'Košík, počet položek: {count}',
    menu: 'Nabídka',
    userMenu: 'Nabídka účtu {name}',
  },
  menu: {
    dashboard: 'Přehled účtu',
    orders: 'Objednávky',
    wishlist: 'Oblíbené',
    billing: 'Platby a peněženka',
    settings: 'Nastavení',
    admin: 'Správa',
    language: 'Jazyk',
    platforms: 'Platformy',
    shopByPrice: 'Nakupovat podle ceny',
    discover: 'Objevujte',
    browseAll: 'Procházet všechny hry',
    comingSoon: 'Již brzy',
  },
  price: {
    under5: 'Do 5 €',
    from5: '5–10 €',
    from10: '10–20 €',
    from20: 'Od 20 €',
  },
  language: {
    aria: 'Změnit jazyk',
  },
  accountFallback: 'Váš účet',
  account: 'Účet',
  login: 'Přihlásit se',
  signup: 'Registrovat se',
};
